import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Plazos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'plazos_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'plazos_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'plazos_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'plazos_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.presupuesto.plazos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.presupuesto.plazos.export}
                title={"Plazos"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Plazos;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Plazos/Plazos.js